 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/Cover'
 import LOVE_1 from '@/components/love_1'
 import TITLE from '@/components/Title'
 import COPYRIGHT from '@/components/Copyright'
 import DEDICATION from '@/components/Dedication'
 import CONTENTS from '@/components/Contents'
 import INTRODUCTION from '@/components/Introduction'
 import PART001 from '@/components/Part001'
 import CHAPTER001 from '@/components/Chapter001'
 import CHAPTER002 from '@/components/Chapter002'
 import PART002 from '@/components/Part002'
 import CHAPTER003 from '@/components/Chapter003'
 import CHAPTER004 from '@/components/Chapter004'
 import CHAPTER005 from '@/components/Chapter005'
 import CHAPTER006 from '@/components/Chapter006'
 import CHAPTER007 from '@/components/Chapter007'
 import PART003 from '@/components/Part003'
 import CHAPTER008 from '@/components/Chapter008'
 import CHAPTER008SEC41 from '@/components/Chapter008sec41'
 import CHAPTER008SEC42 from '@/components/Chapter008sec42'
 import CHAPTER008SEC43 from '@/components/Chapter008sec43'
 import CHAPTER008SEC44 from '@/components/Chapter008sec44'
 import CHAPTER008SEC45 from '@/components/Chapter008sec45'
 import CHAPTER009 from '@/components/Chapter009'
 import CHAPTER009SEC47 from '@/components/Chapter009sec47'
 import CHAPTER009SEC48 from '@/components/Chapter009sec48'
 import CHAPTER009SEC49 from '@/components/Chapter009sec49'
 import CHAPTER009SEC50 from '@/components/Chapter009sec50'
 import CHAPTER009SEC51 from '@/components/Chapter009sec51'
 import CHAPTER009SEC52 from '@/components/Chapter009sec52'
 import CHAPTER010 from '@/components/Chapter010'
 import CHAPTER010SEC54 from '@/components/Chapter010sec54'
 import CHAPTER010SEC55 from '@/components/Chapter010sec55'
 import CHAPTER010SEC56 from '@/components/Chapter010sec56'
 import CHAPTER011 from '@/components/Chapter011'
 import CHAPTER011SEC58 from '@/components/Chapter011sec58'
 import CHAPTER011SEC59 from '@/components/Chapter011sec59'
 import CHAPTER011SEC60 from '@/components/Chapter011sec60'
 import CHAPTER011SEC61 from '@/components/Chapter011sec61'
 import CHAPTER011SEC62 from '@/components/Chapter011sec62'
 import CHAPTER011SEC63 from '@/components/Chapter011sec63'
 import CHAPTER011SEC64 from '@/components/Chapter011sec64'
 import CHAPTER011SEC65 from '@/components/Chapter011sec65'
 import CHAPTER012 from '@/components/Chapter012'
 import CHAPTER012SEC67 from '@/components/Chapter012sec67'
 import CHAPTER012SEC68 from '@/components/Chapter012sec68'
 import CHAPTER012SEC69 from '@/components/Chapter012sec69'
 import CHAPTER012SEC70 from '@/components/Chapter012sec70'
 import CHAPTER012SEC71 from '@/components/Chapter012sec71'
 import CHAPTER012SEC72 from '@/components/Chapter012sec72'
 import CHAPTER012SEC73 from '@/components/Chapter012sec73'
 import CHAPTER013 from '@/components/Chapter013'
 import CHAPTER013SEC75 from '@/components/Chapter013sec75'
 import CHAPTER013SEC76 from '@/components/Chapter013sec76'
 import CHAPTER013SEC77 from '@/components/Chapter013sec77'
 import CHAPTER013SEC78 from '@/components/Chapter013sec78'
 import CHAPTER013SEC79 from '@/components/Chapter013sec79'
 import CHAPTER013SEC80 from '@/components/Chapter013sec80'
 import CHAPTER013SEC81 from '@/components/Chapter013sec81'
 import CHAPTER014 from '@/components/Chapter014'
 import CHAPTER014SEC83 from '@/components/Chapter014sec83'
 import CHAPTER014SEC84 from '@/components/Chapter014sec84'
 import CHAPTER014SEC85 from '@/components/Chapter014sec85'
 import CHAPTER014SEC86 from '@/components/Chapter014sec86'
 import LOVE_2 from '@/components/love_2'
 import APPENDIX from '@/components/Appendix'
 import APPENDIXSEC88 from '@/components/Appendixsec88'
 import APPENDIXSEC89 from '@/components/Appendixsec89'
 import APPENDIXSEC90 from '@/components/Appendixsec90'
 import APPENDIXSEC91 from '@/components/Appendixsec91'
 import APPENDIXSEC92 from '@/components/Appendixsec92'
 import APPENDIXSEC93 from '@/components/Appendixsec93'
 import ACKNOWLEDGMENTS from '@/components/Acknowledgments'
 import AUTHOR from '@/components/Author'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Contents",
 			"name" : "Contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/Introduction",
 			"name" : "Introduction",
 			"component" : INTRODUCTION
 		},
 		{
 			"path" : "/Part001",
 			"name" : "Part001",
 			"component" : PART001
 		},
 		{
 			"path" : "/Chapter001",
 			"name" : "Chapter001",
 			"component" : CHAPTER001
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js